<template>
  <header class="dentist-container header" id="header">
    <div class="row no-gutters align-items-center">
      <div class="d-none d-sm-block col-sm-4 col-md-4 col-lg-3 col-xl-3 order-sm-1 order-md-0">
        <SearchPatient class="ml-sm-3 ml-md-0"
                       v-if="!isPatient && isPaid"/>
      </div>
      <div class="d-block d-md-none col-sm-auto col-4 order-md-1 order-sm-0">
        <MenuToggler view="header"/>
        <router-link to="/calendar">
          <img :src="`/images/general/${!isDentalClinic ? 'logo_medical_short.png' : 'logo_short.png'}`"
               class="header__logo"/>
        </router-link>
      </div>
      <div class="text-right col-sm col-md-8 col-lg-9 col-xl-9 col-8 order-2">
        <div class="header-item-wrapper d-flex align-items-center justify-content-end pl-xl-4 pl-md-4">
          <HeaderAddPatient class="header__item"
                            v-if="rights.includes('add_clients') && isPaid"/>
          <HeaderWaitingList class="header__item"
                             v-if="rights.includes('waiting_list') && isPaid"/>
          <HeaderTasks class="header__item"
                       v-if="!isPatient && isPaid && rights.includes('tasks')"/>
<!--          <HeaderCallPlanning class="header__item ml-xl-5 ml-md-3 ml-0" v-if="!isPatient && isPaid && rights.includes('call_planning')"/>-->
          <HeaderCRM class="header__item"
                     v-if="!isPatient && isPaid && (rights.includes('tasks') || rights.includes('crm'))"/>
          <HeaderWazzup class="header__item"
                        v-if="!isPatient && isPaid"/>
          <!--                    <HeaderCalls class="header__item ml-5"/>-->
          <HeaderBirthday class="header__item"
                          v-if="!isPatient && isPaid && rights.includes('birthday')"/>
          <HeaderReports v-if="showReports"
                         class="header__item"/>
          <HeaderNotifications class="header__item"
                               v-if="!isPatient && showNotifications && isPaid"/>
          <HeaderJetApiToggler class="header__item"
                               v-if="!isPatient && jetAPIEnabled && rights.includes('jet_api')"/>
          <HeaderGreenApiToggler class="header__item"
                                 platform="whatsapp"
                                 v-if="!isPatient && greenAPIWhatsappPanelEnabled && rights.includes('green_api')"/>
          <HeaderGreenApiToggler class="header__item"
                                 platform="max"
                                 v-if="!isPatient && greenAPIMaxPanelEnabled && rights.includes('max')"/>
          <HeaderGreenApiToggler class="header__item"
                                 platform="telegram"
                                 v-if="!isPatient && greenAPITelegramPanelEnabled && rights.includes('green_api_telegram')"/>
          <HeaderAuraPanelToggler class="header__item" v-if="!isPatient && auraPanelEnabled && rights.includes('aurasystems')"/>
          <HeaderUser class="header__item"/>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import SearchPatient from "../parts/header/SearchPatient"
import HeaderUser from "../parts/header/HeaderUser"
import HeaderAddPatient from "../parts/header/HeaderAddPatient"
import HeaderTasks from "../parts/header/HeaderTasks"
import HeaderCRM from "../parts/header/HeaderCRM"
import HeaderNotifications from "../parts/header/HeaderNotifications"
import MenuToggler from "@/components/parts/header/MenuToggler"
import {useStore} from "vuex"
import HeaderWaitingList from "@/components/parts/header/HeaderWaitingList"
import HeaderBirthday from "@/components/parts/header/HeaderBirthday"
import { UsersService } from "@/services/api/users.api.service"
import HeaderWazzup from "@/components/parts/header/HeaderWazzup"
import HeaderJetApiToggler from "@/components/parts/header/HeaderJetApiToggler.vue"
import HeaderGreenApiToggler from "@/components/parts/header/HeaderGreenApiToggler.vue"
import HeaderAuraPanelToggler from "@/components/parts/header/HeaderAuraPanelToggler.vue"
import HeaderReports from "@/components/parts/header/HeaderReports.vue"
import {computed, onMounted, ref, watch} from "vue"

const store = useStore()

const showNotifications = ref(true)

const rights = computed(() => store.state.auth.rights || [])
const headerUpdateCounter = computed(() => store.state.auth.headerUpdateCounter)
const getters = store.getters
const isPaid = computed(() => getters.isPaid)
const isLogged = computed(() => getters.isLogged)
const isDentalClinic = computed(() => getters.isDentalClinic)
const jetAPIEnabled = computed(() => getters.jetAPIEnabled)
const isPatient = computed(() => getters.isPatient)
const greenAPIWhatsappPanelEnabled = computed(() => getters.greenAPIPanelEnabled)
const greenAPIMaxPanelEnabled = computed(() => getters.greenAPIMaxPanelEnabled)
const greenAPITelegramPanelEnabled = computed(() => getters.greenAPITelegramPanelEnabled)
const auraPanelEnabled = computed(() => getters.auraPanelEnabled)
const headerCounters = computed(() => store.state.auth.headerCounters || {})

const getData = () => {
  if(!isLogged.value) return
  UsersService.counters().then(res => {
    const d = res.data
    store.commit('setHeaderCounter', { counter: 'waiting', value: d.waiting } )
    store.commit('setHeaderCounter', { counter: 'tasks', value: d.tasks } )
    store.commit('setHeaderCounter', { counter: 'birthdays', value: d.birthdays } )
    store.commit('setHeaderCounter', { counter: 'unread', value: d.unread } )
    store.commit('setHeaderCounter', { counter: 'excels', value: d.excels || 0 } )
  })
}

watch(headerUpdateCounter, () => {
  getData()
})

onMounted(() => {
  setTimeout(getData, 3000)
})

const showReports = computed(() => {
  return (headerCounters.value?.excels || 0) > 0
})
</script>
